/**
 * Stažení oceňovací zprávy v PDF.
 *
 * Zpráva se tiskne rovnou z výsledků, bez předchozího hledání konkurentů.
 * Dohledání srovnatelných firem v rejstříku trvalo minuty, cestou ho
 * utnul časový limit a výběr nebyl spolehlivý (k hračkářství přiřadil
 * optiku). Kapitola srovnání se bez vzorku ve zprávě vynechá, ostatní
 * kapitoly (metoda, můstek, kontrola, rizika, plán) stojí na datech klienta.
 */
import React, { useState } from 'react';
import { stahniZpravu } from '../api/zpravaApi';

export function ZpravaPanel({ wizardState }) {
  const [tiskne, setTiskne] = useState(false);
  const [chyba, setChyba] = useState(null);

  const tiskni = async () => {
    setTiskne(true); setChyba(null);
    try {
      await stahniZpravu(wizardState, []);
    } catch (e) {
      setChyba(e.message);
    } finally {
      setTiskne(false);
    }
  };

  return (
    <div className="edit-form" style={{
      marginBottom: '1.5rem', display: 'flex', gap: '1.25rem',
      alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap',
      borderLeft: '4px solid var(--gold)',
    }}>
      <div style={{ flex: '1 1 320px' }}>
        <h3 style={{
          fontFamily: "'Source Serif 4', Georgia, serif",
          fontWeight: 600, fontSize: '1.15rem', margin: '0 0 0.35rem',
        }}>
          Oceňovací zpráva v PDF
        </h3>
        <p style={{ margin: 0, fontSize: '0.87rem', color: 'var(--text-dim)' }}>
          Celé ocenění v jednom dokumentu: hodnota firmy, zvolená metoda a její
          odůvodnění, výpočet krok za krokem, kontrola jiným přístupem, rizika
          a plán zvýšení hodnoty.
        </p>
      </div>
      <button className="btn-primary" onClick={tiskni} disabled={tiskne} style={{ whiteSpace: 'nowrap' }}>
        {tiskne ? 'Sestavuji zprávu…' : 'Stáhnout zprávu (PDF)'}
      </button>
      {chyba && <div className="error-message" style={{ flexBasis: '100%' }}>{chyba}</div>}
    </div>
  );
}

export default ZpravaPanel;
